// extracted by mini-css-extract-plugin
export var button = "_mr-0";
export var donut = "_mr-1";
export var donutFill = "_mr-3";
export var donutTrack = "_mr-2";